import { EndpointConfig } from '@services/api/declarations'

export const getUserLegacyLogoutConfig: EndpointConfig = {
  storeKey: 'getUserLegacyLogout',
  url: '/logout',
}

export const getLegacyPeopleGroupByClubConfig: EndpointConfig = {
  storeKey: 'getLegacyPeopleGroupByClub',
  url: '/api/people-group-by-club',
}

export const getClubTeamsConfig: EndpointConfig = {
  storeKey: 'getClubTeams',
  url: '/api/clubs/:clubHash/teams',
}

export const getClubCategoriesConfig: EndpointConfig = {
  storeKey: 'getClubCategories',
  url: '/api/categories',
}
